/** @format */

const template = `
<div class="tooltip-header">
  <span ng-if="$ctrl.eventData.cancelled" class="tiny-badge danger" translate> SIS_COMPONENTS.CALENDAR.EVENT_CANCELLED </span>
  <span> {{$ctrl.eventData.start | localTimeFormat}}–{{$ctrl.eventData.end | localTimeFormat}} </span>
  <div ng-if="$ctrl.eventData.enrolment.state === 'NOT_ENROLLED'">
    <sis-icon icon="alert-fill"></sis-icon>
    <span>{{'SIS_COMPONENTS.CALENDAR.NOT_ENROLLED' | translate}}</span>
  </div>
</div>
<div class="tooltip-event-name">{{$ctrl.eventData.eventName | localizedString}}</div>
<div class="study-group-set-name">
  {{$ctrl.eventData.studyGroupSetName | localizedString}}, {{$ctrl.eventData.studySubGroupName | localizedString}}
</div>
<div class="event-details">
  <div ng-if="$ctrl.eventData.teachersRemoved">
    <sis-icon icon="person-small" color="white"></sis-icon>
    <div class="event-info-missing" translate>SIS_COMPONENTS.CALENDAR.TEACHERS_REMOVED</div>
  </div>
  <div ng-if="!$ctrl.eventData.teachersRemoved" ng-repeat="teacher in $ctrl.eventData.teachers">
    <sis-icon icon="person-small" color="white"></sis-icon>
    <div class="event-info">{{teacher.fullName}}</div>
  </div>
  <div ng-if="$ctrl.eventData.teachers.length === 0 && !$ctrl.eventData.teachersRemoved">
    <sis-icon icon="person-small" color="white"></sis-icon>
    <div class="event-info-missing" translate>SIS_COMPONENTS.CALENDAR.NO_TEACHER</div>
  </div>
  <div ng-if="$ctrl.eventData.locationsRemoved">
    <sis-icon icon="pin-small" color="white"></sis-icon>
    <div class="event-info-missing" translate>SIS_COMPONENTS.CALENDAR.LOCATIONS_REMOVED</div>
  </div>
  <div ng-if="!$ctrl.eventData.locationsRemoved" ng-repeat="location in $ctrl.eventData.locations">
    <sis-icon icon="pin-small" color="white"></sis-icon>
    <div class="event-info">
      <span>{{location.name | localizedString}}</span
      ><!--
      --><span ng-if="location.building.name">, {{location.building.name | localizedString}}</span>
    </div>
  </div>
  <div ng-if="$ctrl.eventData.locations.length === 0 && !$ctrl.eventData.locationsRemoved">
    <sis-icon icon="pin-small" color="white"></sis-icon>
    <div class="event-info-missing" translate>SIS_COMPONENTS.CALENDAR.NO_LOCATION</div>
  </div>

  <div ng-if="$ctrl.eventData.notice">
    <sis-icon icon="info-small" color="white"></sis-icon>
    <div class="event-info">{{$ctrl.eventData.notice | localizedString}}</div>
  </div>
</div>
`;
export default template;
